
import { computed, defineComponent, type PropType } from "vue";
import type { AllergenStatusVariant } from "@/utils/allergenStatus";

export default defineComponent({
  name: "VAllergenStatusIcon",
  props: {
    variant: {
      type: String as PropType<AllergenStatusVariant>,
      required: true,
    },
    size: {
      type: Number,
      default: 30,
    },
  },
  setup(props) {
    const containsAllergenIcon = require("@/assets/img/allergens/contains-allergen.png");
    const allergenFreeIcon = require("@/assets/img/allergens/allergen-free.png");
    const pendingAnalysisIcon = require("@/assets/img/allergens/pending-analysis.png");

    const iconSrc = computed(() => {
      if (props.variant === "detected") {
        return containsAllergenIcon;
      }

      if (props.variant === "free") {
        return allergenFreeIcon;
      }

      return pendingAnalysisIcon;
    });

    const iconStyle = computed(() => ({
      width: `${props.size}px`,
      height: `${props.size}px`,
    }));

    return {
      iconSrc,
      iconStyle,
    };
  },
});
